import { render, staticRenderFns } from "./SwModalSidebar.vue?vue&type=template&id=920c8b30"
import script from "./SwModalSidebar.vue?vue&type=script&lang=js"
export * from "./SwModalSidebar.vue?vue&type=script&lang=js"
import style0 from "./SwModalSidebar.vue?vue&type=style&index=0&id=920c8b30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports